module.exports = __webpack_public_path__ + "static/media/insurance.a41af116.png";